import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.comments.list;
export const commentsListData = createSelector([baseState], (state) => {
    return Object.values(state.data).map(i => {
        let comment = i.comment;
        let clean = i.comment;
        i.tags.forEach(tag => {
            comment = comment.replace("$TAG", `[${tag.key}](#/people/${tag.value})`);
            clean = clean.replace("$TAG", tag.key);
        });
        return {
            ...i,
            comment: comment,
            clean: clean
        };
    }).sort(((a, b) => {
        return b.index < a.index ? 1 : -1;
    }));
});
export const commentsListFetchData = createSelector([baseState], (state) => {
    return {
        type: state.type,
        id: state.resource_id,
        order_by: state.order_by
    };
});
export const commentsListCurrentPage = createSelector([baseState], (state) => {
    return state.current_page;
});
export const commentsListTotalItems = createSelector([baseState], (state) => {
    return state.metadata.totalItems;
});
export const commentsListLoading = createSelector([baseState, commentsListCurrentPage], (state, page) => {
    return state.status === ReducerStatuses.LOADING && page === 0
});
export const commentsListHasNext = createSelector([baseState], (state) => {
    return !!state.metadata.hasNext;
});
export const commentsListOrderBy = createSelector([baseState], (state) => {
    return state.order_by;
});
export const commentsListNextLoading = createSelector([baseState, commentsListCurrentPage], (state, page) => {
    return state.status === ReducerStatuses.LOADING  && page !== 0
});
export const commentsListErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    }
});